import API_BASE from '@/lib/apiBase';
import { http } from '@/lib/http';

export type MinimalRetailer = { id: number; name: string };

// Fetch retailers for a specific campaign. Returns [] on 404.
export async function getRetailersByCampaignId(campaignId: number): Promise<MinimalRetailer[]> {
  // Derive from campaign stores + all retailers list (avoids calling missing endpoint)
  try {
    const [storesRes, retailersRes] = await Promise.all([
      http(`${API_BASE}/api/campaigns/${campaignId}/stores`, { credentials: 'omit', component: 'retailersApi.fallback.stores' }),
      http(`${API_BASE}/api/retailers`, { credentials: 'omit', component: 'retailersApi.fallback.retailers' })
    ]);
    if (!storesRes.ok || !retailersRes.ok) return [];
    const [stores, retailers] = await Promise.all([storesRes.json(), retailersRes.json()]);
    const retailerId = Array.isArray(stores)
      ? (stores.find((s: any) => s.store?.retailerId)?.store?.retailerId ?? null)
      : null;
    if (!retailerId) return [];
    const retailer = (Array.isArray(retailers) ? retailers : []).find((r: any) => r.id === retailerId);
    return retailer ? [{ id: retailer.id, name: retailer.name }] : [];
  } catch {
    return [];
  }
}

// Optional hook if needed elsewhere
export { }
